import React, { useState } from "react";
import Footer from "../Fotter";

function FAQ() {
 
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAnswer = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
    <div className="mx-auto px-4 py-6">
      <div className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Shipping Information</h2>
        <p className="text-gray-600 mb-2">
          BharatCod delivers quality products across India with the convenience of Cash on Delivery (COD).
        </p>
        <p className="text-gray-600 mb-2">
          We are committed to providing excellent customer service and delivering products safely and quickly to your doorstep.
        </p>
        <p className="text-gray-600 mb-2">
          Please note: We currently accept only Cash on Delivery (COD) for all orders. 
        </p>
        <p className="text-gray-600 mb-2">
          A minimal COD charge may apply depending on your order.
        </p>
        <p className="text-gray-600">
          We do not offer any online payment options like UPI, Net Banking, or Credit/Debit Cards at this time.
        </p>
      </div>
  
      {/* FAQ Section */}
      <h1 className="text-3xl font-bold mb-6">Frequently Asked Questions</h1>
  
      {/* Question 1 */}
      <div className="mb-8">
        <button
          onClick={() => toggleAnswer(0)}
          className="w-full text-left text-xl font-semibold py-2 px-4 border-b-2 border-gray-300 hover:bg-gray-100 focus:outline-none"
        >
          Cash On Delivery Available?
        </button>
        {openIndex === 0 && (
          <p className="mt-2 text-gray-600 px-4">
            Yes! All orders at BharatCod are processed with Cash on Delivery (COD) only.
          </p>
        )}
      </div>
  
      {/* Question 2 */}
      <div className="mb-8">
        <button
          onClick={() => toggleAnswer(1)}
          className="w-full text-left text-xl font-semibold py-2 px-4 border-b-2 border-gray-300 hover:bg-gray-100 focus:outline-none"
        >
          Are There Any COD Charges?
        </button>
        {openIndex === 1 && (
          <p className="mt-2 text-gray-600 px-4">
            Yes, a small Cash on Delivery (COD) fee may be applicable, depending on your order value.
          </p>
        )}
      </div>
  
      {/* Question 3 */}
      <div className="mb-8">
        <button
          onClick={() => toggleAnswer(2)}
          className="w-full text-left text-xl font-semibold py-2 px-4 border-b-2 border-gray-300 hover:bg-gray-100 focus:outline-none"
        >
          What Is The Expected Delivery Time?
        </button>
        {openIndex === 2 && (
          <p className="mt-2 text-gray-600 px-4">
            BharatCod delivers products within 5–6 working days across India.
          </p>
        )}
      </div>
  
      {/* Question 4 */}
      <div className="mb-8">
        <button
          onClick={() => toggleAnswer(3)}
          className="w-full text-left text-xl font-semibold py-2 px-4 border-b-2 border-gray-300 hover:bg-gray-100 focus:outline-none"
        >
          Why Should I Buy From BharatCod?
        </button>
        {openIndex === 3 && (
          <ul className="mt-2 text-gray-600 px-4 list-disc">
            <li>High-quality products as per customer needs.</li>
            <li>Fast and reliable shipping across India.</li>
            <li>Only COD available — no need to worry about online transactions!</li>
            <li>Excellent customer support services.</li>
          </ul>
        )}
      </div>
  
      {/* Question 5 */}
      <div className="mb-8">
        <button
          onClick={() => toggleAnswer(4)}
          className="w-full text-left text-xl font-semibold py-2 px-4 border-b-2 border-gray-300 hover:bg-gray-100 focus:outline-none"
        >
          What Is Refurbished Product?
        </button>
        {openIndex === 4 && (
          <p className="mt-2 text-gray-600 px-4">
            Refurbished products are those that have been returned to the seller or manufacturer, tested, repaired if needed, and resold at a discounted price.
          </p>
        )}
      </div>
  
      {/* Question 6 */}
      <div className="mb-8">
        <button
          onClick={() => toggleAnswer(5)}
          className="w-full text-left text-xl font-semibold py-2 px-4 border-b-2 border-gray-300 hover:bg-gray-100 focus:outline-none"
        >
          Is There Any Warranty Available On Products?
        </button>
        {openIndex === 5 && (
          <p className="mt-2 text-gray-600 px-4">
            Yes, refurbished products from BharatCod come with a warranty ranging from 6 months to 1 year.
          </p>
        )}
      </div>
  
      {/* Question 7 */}
      <div className="mb-8">
        <button
          onClick={() => toggleAnswer(6)}
          className="w-full text-left text-xl font-semibold py-2 px-4 border-b-2 border-gray-300 hover:bg-gray-100 focus:outline-none"
        >
          What Is Your Refund And Return Policy?
        </button>
        {openIndex === 6 && (
          <p className="mt-2 text-gray-600 px-4">
            Refund and return policies are clearly mentioned on our website for complete transparency.
          </p>
        )}
      </div>
  
      {/* Question 8 */}
      <div className="mb-8">
        <button
          onClick={() => toggleAnswer(7)}
          className="w-full text-left text-xl font-semibold py-2 px-4 border-b-2 border-gray-300 hover:bg-gray-100 focus:outline-none"
        >
          What Should I Do If I Received Damaged/Defective OR Wrong Product?
        </button>
        {openIndex === 7 && (
          <p className="mt-2 text-gray-600 px-4">
            Please capture pictures or videos of the product and contact BharatCod customer support for quick assistance and replacement.
          </p>
        )}
      </div>
  
      {/* Question 9 */}
      <div className="mb-8">
        <button
          onClick={() => toggleAnswer(8)}
          className="w-full text-left text-xl font-semibold py-2 px-4 border-b-2 border-gray-300 hover:bg-gray-100 focus:outline-none"
        >
          Are There Any Cancellation Charges?
        </button>
        {openIndex === 8 && (
          <p className="mt-2 text-gray-600 px-4">
            No, BharatCod does not charge any fees for order cancellations.
          </p>
        )}
      </div>
    </div>
  
    <Footer />
  </div>
  
  );
}

export default FAQ;
